import toast from 'react-hot-toast';
import smartToast from '../../util/smart_toast';
import secureAxios from '../secure_axios';

const baseUrl = 'indicador/'

async function servPostIndicadorLote(formData) {

    try {
        const response = await smartToast(
            secureAxios.post(baseUrl + 'lote', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            , { loadingMessage: 'Processando planilha enviada...', apenasLoading: false }
        );
        return response
    } catch (error) {
        throw error;
    }

}

async function servBuscarIndicadorParaEdicao(query) {

    try {
        const response = await toast.promise(
            secureAxios.get(`${baseUrl}/buscar-para-edicao`,
                { params: query }
            ), { loading: 'Buscando indicador para edição...' }
        )
        return response
    } catch (error) {
        throw error;
    }

}

export {
    servPostIndicadorLote,
    servBuscarIndicadorParaEdicao
}
